<template>
    <div :class="['affiliate-program', superAdmin ? 'super-admin' : 'user']">
        <div class="affiliate-program-content">
            <i v-if="superAdmin" class="fa fa-close close-icon" @click="closeAffiliateModal()"></i>
            <div v-if="superAdmin" class="header-row">
                <i class="fa fa-pie-chart"></i>
                <h1>{{companyName}}</h1>
            </div>
            <div v-else class="header-row">
                <h1>Affiliate Program</h1>
            </div>
            <div class="summary-control-row">
                <div v-if="superAdmin" class="controls">
                    <button class="btn btn-primary" @click="openCommisionModal()">
                        <i class="fa fa-pie-chart"></i>
                        Change Commision
                    </button>
                    <button class="btn btn-primary" @click="openDisableAffiliateModal()">
                        <i class="fa fa-pie-chart"></i>
                        Disable Program
                    </button>
                </div>
                <div class="summary-box">
                    <h3>{{percentageGain}} %</h3>
                    <h4>Comission Rate</h4>
                </div>
                <div class="summary-box">
                    <h3>{{affiliatedCompanies}}</h3>
                    <h4>Affiliate Companies</h4>
                </div>
                <div class="summary-box">
                    <h3>{{totalPreviousPeriod}}</h3>
                    <h4>Total Previous Period</h4>
                </div>
                <div class="summary-box">
                    <h3>{{totalCommission}}</h3>
                    <h4>Total Commission</h4>
                </div>
                <div class="summary-box">
                    <h3 class="copy">{{referralCode}} <i @click="copyReferal(referralCode)" class="fa fa-files-o"></i></h3>
                    <h4>Referral Code</h4>
                </div>
            </div>
            <div v-if="affiliatedCompanies" class="year-view">
                <div class="year-view-header">
                    <a v-for="year of affiliatesData" @click="selectYear(year.year)" :class="year.year == selectedYear ? 'selected' : ''" :key="'year-link-' + year.year">{{year.year}}</a>
                </div>
                <div class="affiliates-graph">
                    <div class="graph-axes">
                        <div class="YAxis">
                            <div v-for="(point, i) of YAxis" :style="'bottom: calc(' + (25 * i) + '% - 0.5em);'" class="YAxis-point">
                                $ {{point}}
                            </div>
                        </div>
                    </div>
                    <div class="affiliates-data">
                        <div v-for="column of XData" class="column">
                            <div class="column-content" :style="column.columnHeight">
                                <div v-for="part of column.data" class="column-field" :style="part.companyId != companyPreviewId ? part.style : part.highlightStyle">
                                    <div class="graph-tooltip">
                                        <div class="left-bar" :style="part.color"></div>
                                        <div class="text">
                                            <h5>{{part.companyName}}</h5>
                                            <h6>{{part.commission}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="fill">
                                <span class="fill-value">{{column.XTopValue}}</span>
                            </div>
                            <div class="column-title">
                                {{column.XAxis}}
                            </div>
                        </div>
                        <div v-for="(point, i) of YAxis" :style="'bottom: calc(' + (25 * i) + '% - 1px); width: ' + (20 + (100 + 16) * XData.length) + 'px; min-width: ' + width + 'px;'" class="YAxis-line"></div>
                    </div>
                </div>
            </div>
            <div v-if="affiliatedCompanies" class="affiliates-box">
                <div class="affiliate-headers">
                    <h4 class="header affiliate">Affiliate ({{affiliatedCompanies}})</h4>
                    <h4 class="header number-of-periods"># of Periods</h4>
                    <h4 class="header year-to-date">Total Commission</h4>
                    <h4 class="header start-date">Start Date</h4>
                </div>
                <div class="affiliate-rows">
                    <div v-for="affiliate of affiliates" @click="openComissionHistoryModal(affiliate.slaveCompanyId)" @mouseenter="setCompanyPreview(affiliate.slaveCompanyId)" @mouseleave="resetCompanyPreview()" class="affiliate-row">
                        <div class="color-label" :style="companyPreviewId != affiliate.slaveCompanyId ? 'background-color:' + affiliate.color + ';' : 'background-color: #ffc400;'"></div>
                        <div class="cell affiliate-cell">
                            <h3>Affiliate</h3>
                            <h4>{{affiliate.companyName}}</h4>
                        </div>
                        <div class="cell number-of-periods-cell">
                            <h3># of Periods</h3>
                            <span>{{affiliate.noOfPeriods}}</span>
                        </div>
                        <div class="cell year-to-date-cell">
                            <h3>Total Commission</h3>
                            <span>{{affiliate.totalCommission}}</span>
                        </div>
                        <div class="cell start-date-cell">
                            <h3>Start Date</h3>
                            <span>{{affiliate.startDate}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="loading == false && affiliatedCompanies == 0" class="no-affiliates">
                <h2 v-if="superAdmin">This company have no affiliated companies yet.</h2>
                <h2 v-else>You have no affiliated companies yet.</h2>
            </div>
            <div class="loader" v-if="loading">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </div>

            <b-modal id="commision" ref="commision" centered size="md" hide-header hide-footer>
                <i class="fa fa-close close-icon" @click="closeCommisionModal()"></i>
                <i class="fa fa-pie-chart"></i>
                <h3>Commision</h3>
                <p>Set Commision rate for Referal Agent</p>
                <div class="rates-box">
                    <div @click="changePercentageGain(5)" :class="['rate', percentageGain == 5 ? 'selected' : '']">5%</div>
                    <div @click="changePercentageGain(8)" :class="['rate', percentageGain == 8 ? 'selected' : '']">8%</div>
                    <div @click="changePercentageGain(10)" :class="['rate', percentageGain == 10 ? 'selected' : '']">10%</div>
                    <div @click="changePercentageGain(12)" :class="['rate', percentageGain == 12 ? 'selected' : '']">12%</div>
                    <div @click="changePercentageGain(15)" :class="['rate', percentageGain == 15 ? 'selected' : '']">15%</div>
                </div>
                <div class="control-row">
                    <button class="btn btn-light" @click="cancelChangeCommision()">Cancel</button>
                    <button class="btn btn-success" @click="setChangeCommision()" :disabled="initialPercentageGain == percentageGain">Set</button>
                </div>
            </b-modal>

            <b-modal id="disableAffiliateModal" ref="disableAffiliateModal" centered size="md" hide-header hide-footer>
                <i class="fa fa-close close-icon" @click="closeDisableAffiliateModal()"></i>
                <i class="fa fa-pie-chart"></i>
                <h3>Affiliate Program</h3>
                <p>To disable the program for this user you need to set the program allowance to OFF, and Confirm your action.</p>
                <div class="switch-row">
                    <c-switch class="mx-1" color="success" variant="3d" id="disableAffiliate" label v-model="disableAffiliate"></c-switch>
                    <label for="disableAffiliate">Confirm disabling program</label>
                </div>
                <div class="control-row">
                    <button class="btn btn-light" @click="closeDisableAffiliateModal()">Cancel</button>
                    <button class="btn btn-danger" :disabled="disableAffiliate == false" @click="confirmDisabling()">Deactivate</button>
                </div>
            </b-modal>

            <b-modal id="comissionHistoryModal" ref="comissionHistoryModal" centered size="md" hide-header hide-footer>
                <i class="fa fa-close close-icon" @click="closeComissionHistoryModal()"></i>
                <div class="modal-inner">
                    <i class="fa fa-pie-chart"></i>
                    <h3>Commission History</h3>
                    <p>View the history of Commision</p>
                    <table>
                        <thead>
                            <tr>
                                <th>Period start</th>
                                <th>Gain</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row of comissionHistoryData">
                                <td>{{row.billingPeriodDescription}}</td>
                                <td>{{row.commission}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button class="btn btn-light" @click="closeComissionHistoryModal()">Close</button>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { Switch as cSwitch } from "@coreui/vue"
    import variables from "../../variables";
    import Axios from 'axios'
    import globalStore from "../../variables";
    import VueClipboard from 'vue-clipboard2'

    Vue.use(VueClipboard)

    export default {
        name: "AffiliateProgram",
        components: {
            cSwitch
        },
        props: {
            superAdminProp: false,
            companyNameProp: '',
            companyIdProp: null
        },
        data() {
            return {
                affiliatesData: [],
                selectedYear: 0,
                disableAffiliate: false,
                affiliatedCompanies: null,
                totalPreviousPeriod: null,
                totalCommission: null,
                referralCode: null,
                percentageGain: null,
                initialPercentageGain: null,
                superAdmin: false,
                companyName: '',
                companyId: null,
                affiliates: [],
                YAxis: [],
                XData: [],
                comissionHistoryData: [],
                companyColor: [],
                companyPreviewId: null,
                loading: false,
                width: 0
            }
        },
        methods: {
            getAffiliateData() {
                this.loading = true
                Axios.get(globalStore.data.restApiUrl + '/affiliate/customer?companyId=' + this.companyId)
                    .then(response => {
                        if (response.data.affiliates.length > 0 && response.data.billingPeriodAggregatesPerYear.length > 0) {
                            this.affiliatedCompanies = response.data.affiliates.length
                            this.totalPreviousPeriod = '$ ' + response.data.previousPeriodCommissions.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                            this.totalCommission = '$ ' + response.data.totalCommission.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                            this.referralCode = response.data.referralCode
                            this.percentageGain = response.data.percentageGain
                            this.initialPercentageGain = response.data.percentageGain
                            this.affiliates = []
                            let i = 0
                            for (let affiliate of response.data.affiliates) {
                                let template = {}
                                template.companyName = affiliate.companyName
                                template.slaveCompanyId = affiliate.slaveCompanyId
                                template.noOfPeriods = affiliate.noOfPeriods
                                template.startDate = affiliate.startDate
                                template.previousPeriodCommissions = '$ ' + affiliate.previousPeriodCommissions.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                template.totalCommission = '$ ' + affiliate.totalCommission.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                template.color = 'hsl(' + 210 + ', 100%, ' + (50 + (50 / response.data.affiliates.length * (response.data.affiliates.length - 1)) - (i * (50 / response.data.affiliates.length))) + '%)'
                                this.affiliates.push(template)
                                this.companyColor.push({
                                    id: affiliate.slaveCompanyId,
                                    color: 'hsl(' + 210 + ', 100%, ' + (50 + (50 / response.data.affiliates.length * (response.data.affiliates.length - 1)) - (i * (50 / response.data.affiliates.length))) + '%)'
                                })
                                i++
                            }
                            let year = 0
                            let currentYearData = {}
                            this.affiliatesData = response.data.billingPeriodAggregatesPerYear
                            for (let data of this.affiliatesData) {
                                if (data.year > year) {
                                    currentYearData = data.affiliateBillingPeriodAggregates
                                    this.selectedYear = data.year
                                }
                            }
                            this.parseGraphData(currentYearData);
                        } else {
                            this.percentageGain = 0
                            this.affiliatedCompanies = 0
                            this.totalPreviousPeriod = 0
                            this.totalCommission = 0
                            this.referralCode = response.data.referralCode
                        }
                        this.loading = false
                    })
            },
            selectYear(year) {
                this.selectedYear = year
                let selectedYearData = {}
                for (let data of this.affiliatesData) {
                    if (data.year == this.selectedYear) {
                        selectedYearData = data.affiliateBillingPeriodAggregates
                        break;
                    }
                }

                this.parseGraphData(selectedYearData)
            },
            parseGraphData(data) {
                let highestAmount = 0
                for (let row of data) {
                    let periodScore = 0
                    for (let company of row.slaveCompanyCommissions) {
                        periodScore += company.commission
                    }
                    if (periodScore > highestAmount) {
                        highestAmount = periodScore
                    }
                }
                let amountLength = Number(String(Math.round(highestAmount)).length)
                let amountLengthPow = Math.pow(10, amountLength - 2)
                highestAmount = Math.round(highestAmount/amountLengthPow)*amountLengthPow + amountLengthPow
                let YAxis = []
                for (let i = 0; i < 4; i++) {
                    YAxis.push(Math.round(highestAmount / 4 * i))
                }
                YAxis.push(highestAmount)
                this.YAxis = YAxis;
                this.XData = []

                for (let row of data) {
                    let columnTemplate = {
                        XAxis: row.billingPeriod,
                        data: [],
                        columnHeight: 0,
                        maxId: 0
                    }
                    let topValue = 0
                    let columnHeight = 0
                    let max = 0
                    for (let company of row.slaveCompanyCommissions) {
                        columnHeight = columnHeight + company.commission
                        if (company.commission > max) {
                            columnTemplate.maxId = company.slaveId
                        }
                    }
                    columnTemplate.columnHeight = 'height: ' + (columnHeight / highestAmount) * 100 + '%'
                    for (let company of row.slaveCompanyCommissions) {
                        let template = {
                            companyId: company.slaveId,
                            companyName: company.companyName,
                            commission: '$ ' + company.commission.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        }
                        topValue += company.commission
                        let style = ''
                        for (let compColor of this.companyColor) {
                            if (company.slaveId == compColor.id) {
                                let heightStyle = ''
                                if (company.slaveId != columnTemplate.maxId) {
                                    heightStyle = 'height: ' + (company.commission / columnHeight) * 100 + '%;'
                                } else {
                                    heightStyle = 'flex-grow: 1;'
                                }
                                style = 'background-color:' + compColor.color +'; ' + heightStyle
                                template.color = 'background-color: ' + compColor.color + ';'
                                break
                            }
                        }
                        if (window.innerWidth < 992) {
                            template.highlightStyle = style;
                        } else {
                            template.highlightStyle = 'background-color: #ffc400; height: ' + (company.commission / columnHeight) * 100 + '%; box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.16);'
                        }

                        template.style = style
                        columnTemplate.data.push(template)
                    }
                    columnTemplate.XTopValue = '$ ' + topValue.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                    this.XData.push(columnTemplate)
                }

                setTimeout(() => {
                    this.width = document.querySelector('.affiliates-data').offsetWidth
                }, 100)
            },
            closeAffiliateModal() {
                this.$emit('triggerClose', false)
            },
            openCommisionModal() {
                this.$refs['commision'].show();
            },
            closeCommisionModal() {
                this.$refs['commision'].hide();
            },
            openDisableAffiliateModal() {
                this.disableAffiliate = false
                this.$refs['disableAffiliateModal'].show();
            },
            closeDisableAffiliateModal() {
                this.$refs['disableAffiliateModal'].hide();
            },
            openComissionHistoryModal(id) {
                Axios.get(globalStore.data.restApiUrl + '/affiliate/customer/commission-history?slaveCompanyId=' + id + '&companyId=' + this.companyId)
                    .then(response => {
                        this.comissionHistoryData = []
                        for (let row of response.data) {
                            let template = {
                                billingPeriodDescription: row.billingPeriodDescription,
                                commission: '$ ' + row.commission.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                                percentageCommission: row.percentageCommission + '%'
                            }
                            this.comissionHistoryData.push(template)
                        }
                    })
                this.$refs['comissionHistoryModal'].show();
            },
            closeComissionHistoryModal() {
                this.$refs['comissionHistoryModal'].hide();
            },
            copyReferal(referal) {
                this.$copyText(referal)
                    .then( () => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Referal code copied',
                            text: 'Your referal code has been copied to your clipboard.',
                            duration: 3000,
                        });
                    })
            },
            confirmDisabling() {
                Axios.delete(globalStore.data.restApiUrl + '/affiliate/admin?companyId=' + this.companyId)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Affiliate program disabled',
                            text: this.companyName + ' has no longer Affiliate Program.',
                            duration: 3000,
                        });
                        this.$emit('affiliateDisabled', false)
                        this.closeDisableAffiliateModal();
                        this.closeAffiliateModal();
                    })
            },
            changePercentageGain(value) {
                this.percentageGain = value
            },
            cancelChangeCommision() {
                this.percentageGain = this.initialPercentageGain
                this.closeCommisionModal();
            },
            setChangeCommision() {
                let parsedData = {
                    percentageGain: this.percentageGain / 100
                }
                Axios.patch(globalStore.data.restApiUrl + '/affiliate/admin/commission?companyId=' + this.companyId, parsedData)
                    .then(response => {
                        this.initialPercentageGain = this.percentageGain
                        this.closeCommisionModal();
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Commision changed',
                            text: 'Commision for ' + this.companyName + ' is set as ' + this.percentageGain + '%.',
                            duration: 3000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Commision not changed',
                            text: 'An error occured during changing commision.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            },
            setCompanyPreview(id) {
                this.companyPreviewId = id
                //#ffc400
            },
            resetCompanyPreview() {
                this.companyPreviewId = null
            }
        },
        mounted() {
            document.onkeydown = evt => {
                evt = evt || window.event;
                if (evt.keyCode == 27) {
                    this.closeAffiliateModal()
                }
            };
            if (this.superAdminProp == undefined) {
                this.superAdmin = false
                this.companyName = this.$cookies.get('companyName') ? this.$cookies.get('companyName') : this.$session.get('companyName')
            } else {
                this.superAdmin = this.superAdminProp
                this.companyName = this.companyNameProp
            }
            if (this.companyIdProp == undefined) {
                this.companyId = this.$cookies.get('companyId') ? this.$cookies.get('companyId') : this.$session.get('companyId');
            } else {
                this.companyId = this.companyIdProp
            }
            this.getAffiliateData();
        }
    }
</script>

<style lang="scss">
    .affiliate-program {
        &.super-admin {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1040;
            .affiliate-program-content {
                position: relative;
                width: calc(100vw - 200px);
                max-width: 1720px;
                max-height: calc(100vh - 40px);
                margin: 20px 100px;
                padding: 20px 20px 0;
                background-color: #fff;
                border: 1px solid #c9cfd4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;

                .loader {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;

                    background-color: rgba(255, 255, 255, 0.7);

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;

                    .sk-wave {
                        height: 60px;
                        .sk-rect {
                            width: 3px;
                            background-color: #39c354;
                            border-radius: 4px;
                        }
                    }

                    .text {
                        margin-top: 20px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }

                .close-icon {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    cursor: pointer;
                }
            }
        }

        &.user {
            .affiliate-program-content {
                margin: 0 0 20px;
                padding: 20px;
                background-color: #fff;
                border: 1px solid #c9cfd4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                overflow: auto;

                .close-icon {
                    display: none;
                }

                .loader {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;

                    background-color: rgba(255, 255, 255, 0.7);

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;

                    .sk-wave {
                        height: 60px;
                        .sk-rect {
                            width: 3px;
                            background-color: #39c354;
                            border-radius: 4px;
                        }
                    }

                    .text {
                        margin-top: 20px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
            }
        }

        .affiliate-program-content {
            .header-row {
                display: flex;
                align-items: center;
                margin: 0 0 20px;
                .fa-pie-chart {
                    margin: 0 20px 0 0;
                    font-size: 20px;
                    color: #0088ff;
                }
                h1 {
                    margin: 0;
                    font-size: 15px;
                    font-weight: 700;
                }
            }
            .summary-control-row {
                display: flex;
                flex-wrap: wrap;
                .controls {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 200px;
                    margin: 0 20px 20px 0;
                    .btn {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        margin: 0 0 8px;
                        font-size: 17px;
                        i {
                            margin-right: 6px;
                            font-size: 20px;
                        }
                        &:last-child {
                            margin: 0;
                        }
                    }
                }
                .summary-box {
                    width: 200px;
                    margin: 0 20px 20px 0;
                    padding: 20px;
                    background-color: #f2f2f2;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    h3 {
                        margin: 0 0 9px;
                        font-size: 20px;
                        &.copy {
                            display: flex;
                            align-items: center;
                            .fa-files-o {
                                margin: 0 0 0 20px;
                                font-size: 20px;
                                color: #0088FF;
                                cursor: pointer;
                            }
                        }
                    }
                    h4 {
                        margin: 0;
                        font-size: 14px;
                        font-weight: 400;
                    }
                }
            }
            .year-view {
                overflow: auto;
                .year-view-header {
                    margin: 0 0 40px;
                    a {
                        margin: 0 20px 0 0;
                        font-size: 15px;
                        font-weight: 700;
                        cursor: pointer;
                        &.selected {
                            color: #0088ff;
                        }
                    }
                }
                .affiliates-graph {
                    position: relative;
                    height: 300px;
                    margin: 40px 40px 40px 80px;
                    border-left: 1px solid #c9cfd4;
                    .graph-axes {
                        position: absolute;
                        left: -100px;
                        height: 100%;
                        .YAxis {
                            position: relative;
                            height: 100%;
                            .YAxis-point {
                                position: absolute;
                                width: 80px;
                                white-space: nowrap;
                                text-align: right;
                                z-index: 2;
                            }
                        }
                    }
                    .affiliates-data {
                        position: relative;
                        height: 100%;
                        //width: calc(100% - 160px);
                        display: flex;
                        flex-wrap: nowrap;
                        margin: 0 20px;
                        .YAxis-line {
                            position: absolute;
                            left: -20px;
                            right: -20px;
                            height: 1px;
                            background-color: #c9cfd4;
                            z-index: 0;
                        }
                        .column {
                            position: relative;
                            height: 100%;
                            width: 100px;
                            display: flex;
                            flex-direction: column-reverse;
                            margin: 0 16px 0 0;
                            z-index: 1;
                            .column-content {
                                display: flex;
                                flex-direction: column-reverse;
                            }
                            .column-field {
                                position: relative;
                                width: 100px;
                                min-height: 10px;
                                cursor: pointer;
                                .graph-tooltip {
                                    position: absolute;
                                    bottom: calc(50% + 10px);
                                    left: -10px;
                                    right: -10px;
                                    max-width: 120px;
                                    display: none;
                                    padding: 4px 24px 4px 4px;
                                    background-color: #fff;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;
                                    box-shadow: 0px 3px 6px #00000029;
                                    z-index: 10;
                                    &:after {
                                        content: '';
                                        position: absolute;
                                        left: calc(50% - 5px);
                                        right: 0;
                                        top: 100%;
                                        width: 0;
                                        height: 0;
                                        border-left: 10px solid transparent;
                                        border-right: 10px solid transparent;
                                        border-top: 10px solid #fff;
                                        clear: both;
                                    }
                                    .left-bar {
                                        width: 8px;
                                        margin: 0 8px 0 0;
                                        -webkit-border-radius: 2px;
                                        -moz-border-radius: 2px;
                                        border-radius: 2px;
                                    }
                                    .text {
                                        display: flex;
                                        flex-direction: column;
                                        h5 {
                                            margin: 0 0 2px;
                                            color: #2F353A;
                                            font-size: 14px;
                                            font-weight: 400;
                                        }
                                        h6 {
                                            margin: 0;
                                            font-size: 14px;
                                            color: #515B65;
                                            white-space: nowrap;
                                            font-weight: 700;
                                        }
                                    }
                                }
                                &:hover {
                                    .graph-tooltip {
                                        display: flex;
                                    }
                                }
                            }
                            .fill {
                                position: relative;
                                display: flex;
                                align-items: flex-end;
                                justify-content: center;
                                width: 100px;
                                flex-grow: 1;
                                font-weight: 700;
                                .fill-value {
                                    position: absolute;
                                    bottom: 5px;
                                }
                            }
                            .column-title {
                                position: absolute;
                                top: calc(100% + 10px);
                                left: 0;
                                right: 0;
                                font-size: 14px;
                                text-align: center;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
            .affiliates-box {
                margin: 20px 0 0;
                overflow: hidden;
                .affiliate-headers {
                    width: 100%;
                    display: flex;
                    margin: 0;
                    .header {
                        font-size: 15px;
                        font-weight: 700;
                        &.affiliate {
                            width: 30%;
                        }
                        &.number-of-periods {
                            width: 23%;
                        }
                        &.year-to-date {
                            width: 23%;
                        }
                        &.start-date {
                            width: 24%;
                        }
                    }
                }
                .affiliate-rows {
                    display: flex;
                    flex-direction: column;
                    max-height: calc(100vh - 710px);
                    overflow: auto;
                    .affiliate-row {
                        display: flex;
                        margin: 0 0 12px;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                        border: 1px solid #C9CFD4;
                        background-color: #F2F2F2;
                        cursor: pointer;
                        &:hover {
                            border-color: #0088ff;
                        }
                        .color-label {
                            width: 12px;
                            border-top-left-radius: 5px;
                            border-bottom-left-radius: 5px;
                        }
                        .cell {
                            padding: 20px 0;

                            &.affiliate-cell,
                            &.number-of-periods-cell,
                            &.year-to-date-cell,
                            &.start-date-cell {
                                h3 {
                                    display: none;
                                }
                            }

                            &.affiliate-cell {
                                position: relative;
                                width: 30%;
                                h4 {
                                    margin: 0 0 0 24px;
                                    font-size: 14px;
                                    line-height: 24px;
                                    font-weight: 700;
                                }
                                h5 {
                                    margin: 0 0 0 24px;
                                    font-size: 14px;
                                    line-height: 24px;
                                    font-weight: 400;
                                }
                            }
                            &.number-of-periods-cell {
                                width: 23%;
                            }
                            &.year-to-date-cell {
                                width: 23%;
                            }
                            &.start-date-cell {
                                width: 24%;
                            }
                        }
                    }
                }
            }

            .no-affiliates {
                min-height: 300px;
                display: flex;
                align-items: center;
                justify-content: center;
                h2 {
                    font-size: 15px;
                    text-align: center;
                }
            }
        }
    }

    #commision___BV_modal_body_ {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        .close-icon {
            position: absolute;
            top: 25px;
            right: 25px;
            cursor: pointer;
        }
        .fa-pie-chart {
            margin: 25px 0 20px;
            color: #0088ff;
            font-size: 20px;
        }
        h3 {
            margin: 0 0 20px;
            font-size: 15px;
            font-weight: 700;
        }
        p {
            max-width: 360px;
            margin: 0 0 20px;
            text-align: center;
            font-size: 14px;
            line-height: 24px;
        }
        .rates-box {
            display: flex;
            margin: 0 0 30px;
            .rate {
                padding: 8px 20px;
                margin: 0 8px 0 0;
                border: 1px solid #C9CFD4;
                cursor: pointer;
                &:last-child {
                    margin: 0;
                }
                &.selected,
                &:hover {
                    color: #fff;
                    background-color: #0088ff;
                }
            }
        }
        .control-row {
            display: flex;
            justify-content: center;
            .btn-success {
                margin: 0 0 0 10px;
            }
        }
    }

    #disableAffiliateModal___BV_modal_body_ {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        .close-icon {
            position: absolute;
            top: 25px;
            right: 25px;
            cursor: pointer;
        }
        .fa-pie-chart {
            margin: 25px 0 20px;
            color: #0088ff;
            font-size: 20px;
        }

        h3 {
            margin: 0 0 20px;
            font-size: 15px;
            font-weight: 700;
        }
        p {
            max-width: 360px;
            margin: 0 0 20px;
            text-align: center;
            font-size: 14px;
            line-height: 24px;
        }

        .switch-row {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 0 16px;
            padding: 20px 0;
            border-top: 1px solid #c9cfd4;
            border-bottom: 1px solid #c9cfd4;
            label {
                margin: 0 0 0 20px;
            }
        }
        .control-row {
            display: flex;
            justify-content: center;
            .btn-danger {
                margin: 0 0 0 10px;
            }
        }
    }

    #comissionHistoryModal___BV_modal_body_ {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
        background-color: #fff;
        .close-icon {
            position: absolute;
            top: 25px;
            right: 25px;
            cursor: pointer;
        }
        .modal-inner {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .fa-pie-chart {
                margin: 25px 0 20px;
                color: #0088ff;
                font-size: 20px;
            }

            h3 {
                margin: 0 0 12px;
                font-size: 15px;
                font-weight: 700;
            }

            p {
                max-width: 360px;
                margin: 0 0 12px;
                text-align: center;
                font-size: 14px;
                line-height: 24px;
            }

            table {
                width: 100%;

                thead {
                    tr {
                        border-top: 1px solid #d8dce0;
                        border-bottom: 1px solid #d8dce0;

                        th {
                            padding: 10px 0;

                            &:nth-child(1) {
                                width: 50%;
                                padding: 10px 0 10px 20px;
                            }

                            &:nth-child(2) {
                                width: 25%;
                                padding: 10px 20px 10px 0;
                            }
                        }
                    }
                }

                tbody {
                    tr {
                        td {
                            padding: 12px 0;
                            border-bottom: 1px solid #d8dce0;

                            &:nth-child(1) {
                                width: 50%;
                                padding: 10px 0 10px 20px;
                            }

                            &:nth-child(3) {
                                width: 25%;
                                padding: 10px 20px 10px 0;
                            }
                        }

                        &:nth-child(even) {
                            td {
                                background-color: #f0f3f5;
                            }
                        }
                    }
                }
            }
        }
        .btn-light {
            margin: 20px 0;
        }
    }

    .dark-theme {
        .affiliate-program {
            .affiliate-program-content {
                background-color: #3a4149;
                color: #fff;
                border-color: #1a1c1d;
                .summary-control-row {
                    .summary-box {
                        background-color: #2f353a;
                        border-color: #1a1c1d;
                    }
                }
                .year-view {
                    .affiliates-graph {
                        border-color: #1a1c1d;
                        .affiliates-data {
                            .YAxis-line {
                                background-color: #1a1c1d;
                            }
                        }
                    }
                }
                .affiliates-box {
                    .affiliate-rows {
                        .affiliate-row {
                            background-color: #2f353a;
                            border-color: #1a1c1d;
                        }
                    }
                }
            }
        }
        #comissionHistoryModal___BV_modal_body_ {
            background-color: #3a4149;
            table {
                thead {
                    tr {
                        border-color: #1a1c1d;
                    }
                }
                tbody {
                    tr {
                        td {
                            border-color: #1a1c1d;
                        }
                        &:nth-child(even) {
                            td {
                                background-color: #383e45;
                            }
                        }
                    }
                }
            }
        }
        #commision___BV_modal_body_ {
            background-color: #3a4149;
            .rates-box {
                .rate {
                    border-color: #1a1c1d;
                }
            }
        }
        #disableAffiliateModal___BV_modal_body_ {
            background-color: #3a4149;
            .switch-row {
                border-color: #1a1c1d;
            }
        }
    }
    /* RWD */

    @media screen and (max-width: 1599px) {
        .affiliate-program {
            .affiliate-program-content {
                overflow: auto;
                .affiliates-box {
                    .affiliate-rows {
                        max-height: none;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 991px) {
        .affiliate-program {
            &.super-admin {
                top: 55px;
                .affiliate-program-content {
                    width: 100vw;
                    height: calc(100vh - 55px);
                    margin: 0;
                    overflow: scroll;
                }
            }
            .affiliate-program-content {
                .summary-control-row {
                    justify-content: space-evenly;
                }
                .affiliates-box {
                    .affiliate-rows {
                        max-height: none;
                        .affiliate-row {
                            padding: 0 20px 0 0;
                        }
                    }
                }
            }

        }

        #comissionHistoryModal {
            .modal-dialog {
                width: 100vw;
                height: 100vh;
                margin: 0;
                .modal-content {
                    width: 100vw;
                    height: 100vh;
                    .modal-body {
                        width: 100vw;
                        height: 100vh;
                        padding: 55px 0 0;
                        .modal-inner {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            width: 100%;
                            height: calc(100vh - 131px);
                            overflow: auto;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        .affiliate-program {
            .affiliate-program-content {
                .summary-control-row {
                    justify-content: space-between;
                    .controls,
                    .summary-box {
                        margin: 0 0 20px;
                    }
                }
                .affiliates-box {
                    .affiliate-headers {
                        .previous-period,
                        .number-of-periods,
                        .year-to-date,
                        .start-date {
                            display: none;
                        }
                    }
                    .affiliate-rows {
                        .affiliate-row {
                            position: relative;
                            flex-wrap: wrap;
                            padding: 0 0 0 12px;
                            .color-label {
                                position: absolute;
                                left: 0;
                                top: 0;
                                bottom: 0;
                            }
                            .cell {
                                flex-direction: column;
                                align-items: flex-start;
                                &.affiliate-cell,
                                &.number-of-periods-cell,
                                &.year-to-date-cell,
                                &.start-date-cell {
                                    display: flex;
                                    flex-direction: column;
                                    width: calc(50% - 20px);
                                    margin: 0 0 20px 12px;
                                    padding: 0;
                                    h3 {
                                        display: initial;
                                        width: 150px;
                                        margin: 0 20px 0 0;
                                        font-size: 14px;
                                        font-weight: 400;
                                    }
                                    span {
                                        font-weight: 700;
                                    }
                                }
                                &.affiliate-cell {
                                    width: 100%;
                                    margin-top: 20px;
                                    h3 {
                                        display: none;
                                    }
                                    h4 {
                                        margin: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 450px) {
        .affiliate-program {
            .affiliate-program-content {
                .controls {
                    width: 100%;
                    .btn {
                    }
                }
                .summary-control-row {
                    .controls {
                        width: 100%;
                    }
                    .summary-box {
                        width: 100%;
                        margin: 0 0 20px;
                    }
                }
                .affiliates-box {
                    .affiliate-rows {
                        .affiliate-row {
                            .cell {
                                justify-content: space-between;
                                &.affiliate-cell,
                                &.number-of-periods-cell,
                                &.year-to-date-cell,
                                &.start-date-cell {
                                    width: 50%;
                                    margin: 0;
                                    padding: 0 20px 20px 12px;
                                    h3 {
                                        width: initial;
                                        margin: 0;
                                    }
                                }
                                &.affiliate-cell {
                                    width: 100%;
                                    margin-top: 20px;
                                }
                            }
                        }
                    }
                }
            }
        }
        #commision___BV_modal_body_ {
            .rates-box {
                flex-wrap: wrap;
                justify-content: center;
                .rate {
                    margin: 0 8px 8px;
                    &:last-child {
                        margin: 0 8px 8px;
                    }
                }
            }
        }
    }

</style>
